import { predicates } from "../predicates";
import type { ObjectTypeConfig } from "../types";

export const CONNECTOR: ObjectTypeConfig = {
  actions: [
    {
      id: "star",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.isFavorite,
    },
    {
      id: "unstar",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: { not: predicates.isFavorite },
    },
    {
      id: "manage",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
  ],
};
